<mat-dialog-content>
    <mat-card-title class="content-block">
        {{headerText | translate : values}}
    </mat-card-title>
    <mat-card-content class="content-block">
        {{contentText | translate}}
    </mat-card-content>
    <mat-card-actions class="button-div">
        <app-button [buttonType]="'secondary'" (click)="emit(false)" [label]="'confirmation.no' | translate"></app-button>
        <app-button [buttonType]="'primary'" (click)="emit(true)" [label]="'confirmation.yes' | translate"></app-button>
    </mat-card-actions>
</mat-dialog-content>
